import assert from "assert";
// Retire undefined fields for comparison
function normalize(obj) {
    if (Array.isArray(obj)) {
        return obj.map(normalize);
    }
    else if (obj && typeof obj === "object") {
        const res = {};
        for (const [k, v] of Object.entries(obj)) {
            if (v !== undefined)
                res[k] = normalize(v);
        }
        return res;
    }
    return obj;
}
export function deepStrictEqual(a_, b_, options) {
    const a = options?.undefinedDifferentNoKeyInObject ? a_ : normalize(a_);
    const b = options?.undefinedDifferentNoKeyInObject ? b_ : normalize(b_);
    try {
        assert.deepStrictEqual(a, b);
        return true;
    }
    catch (err) {
        return false;
    }
}
export const countDeepDifferences = (var1, var2) => {
    let count = 0;
    if (typeof var1 === "object" && typeof var2 === "object") {
        if (Array.isArray(var1) && Array.isArray(var2)) {
            if (!deepStrictEqual(var1, var2)) {
                count++;
            }
        }
        else {
            if (var1 !== var2) {
                const keys1 = Object.keys(var1);
                const keys2 = Object.keys(var2);
                const keys = new Set([...keys1, ...keys2]);
                for (const key of keys) {
                    count += countDeepDifferences(var1[key], var2[key]);
                }
            }
        }
    }
    else {
        if (var1 !== var2) {
            count++;
        }
    }
    return count;
};
// Fonction donnant la version stringifiée d'un objet toujours dans le même ordre de clés, peut importe l'ordre d'entrée.
export function stableStringify(value) {
    if (typeof value === "function") {
        return value.toString();
    }
    if (value === null || typeof value !== "object") {
        return JSON.stringify(value);
    }
    if (Array.isArray(value)) {
        return "[" + value.map(stableStringify).join(",") + "]";
    }
    const obj = value;
    return ("{" +
        Object.keys(obj)
            .sort()
            .map((key) => JSON.stringify(key) + ":" + stableStringify(obj[key]))
            .join(",") +
        "}");
}
